package io.horion.cv.models

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Theme (
    val hex: String,
    val rgb: CSSColorValue) {

    Blue(hex = "1D40AE", rgb = rgb(r = 29, g = 64, b = 174)),
    White(hex = "#FFFFFF", rgb = rgb(r = 255, g = 255, b = 255)),
    LightBlack(hex = "#474747", rgb = rgb(r = 71, g = 71, b = 71)),
    LightBlue(hex = "#06B6D4", rgb = rgb(r = 6, g = 182, b = 212)),
    LighterGray(hex = "#A3A2A2", rgb = rgb(r = 163, g = 162, b = 162)),
    LighterBlue(hex = "2C3657", rgb = rgb(r = 44, g = 54, b = 87)),

}